import { z } from 'zod';
import { playerCatalogTrackSchema } from './playback.js';
import { playerFacetGroupSchema } from './player-discovery.js';
/**
 * Track search with tag filters (STORY-100): the chips, the count of every
 * match and keyset pages. New routes beside `GET /player/catalog/search`, whose
 * schemas stay as they are (ADR-038): a tab still running the old bundle keeps
 * calling and parsing the old route.
 */
/**
 * `GET /player/tracks/facets` — the tag categories and tags that have client
 * names and are on tracks the venue can play. The «Подборки» group shape, so
 * the player reuses its chips: `kind` is always `'multi'`, `count` is the
 * venue's playable tracks that carry the tag, `is_venue_default` is `false`.
 */
export const playerTrackFacetsResponseSchema = z
    .object({
    groups: z.array(playerFacetGroupSchema),
})
    .strict();
/** The service's cap on chips; `tag_ids` must hold that many uuids and their commas. */
const MAX_TAG_IDS = 30;
const UUID_LENGTH = 36;
const MAX_TAG_IDS_LENGTH = MAX_TAG_IDS * UUID_LENGTH + (MAX_TAG_IDS - 1);
function namesTagId(tagIds) {
    return tagIds !== undefined && tagIds.split(',').some((id) => id.trim().length > 0);
}
/**
 * `GET /player/tracks/search` query string.
 *
 * `tag_ids` is the comma-separated list of `GET /player/presets/search`: the
 * server validates each id, caps the list at 30, ORs the ids of one category
 * and ANDs the categories (ADR-031). Text, chips or both — with neither the
 * search would list the whole catalogue, which the player never shows (CEO
 * 2026-10-28), so that is a 400; a `tag_ids` of commas only names no chip.
 *
 * `cursor` is opaque and carries the last row's title (up to 500 characters),
 * hence a bound well above the 1024 of the preset lists.
 */
export const playerTrackSearchQuerySchema = z
    .object({
    q: z.string().trim().min(2).max(120).optional(),
    tag_ids: z.string().max(MAX_TAG_IDS_LENGTH).optional(),
    limit: z.coerce.number().int().min(1).max(50).default(30),
    cursor: z.string().max(4096).optional(),
})
    .strict()
    .refine((query) => query.q !== undefined || namesTagId(query.tag_ids), {
    message: 'q or tag_ids is required',
});
/**
 * `GET /player/tracks/search` — one page of today's search rows, `total` (every
 * match of the text and the chips, counted without the cursor — «Найдено: N
 * треков», the same on every page) and the cursor of the next page, `null` on
 * the last one.
 */
export const playerTrackSearchResponseSchema = z
    .object({
    items: z.array(playerCatalogTrackSchema),
    total: z.number().int().nonnegative(),
    next_cursor: z.string().nullable(),
})
    .strict();
//# sourceMappingURL=player-track-search.js.map